import type { GridClipboard } from "./useGridClipboard";

// web-rnw twin of ./useGridClipboard.ts (#336 slice 6 part 3): the menu's Copy
// and Paste go through navigator.clipboard, as the keys go through the DOM's
// copy and paste events. A browser may refuse (no permission, no secure
// context): that is a false or a null here, and the caller says so.
// This package compiles without the DOM lib: the little used is declared here.

type ClipboardApi = {
  writeText?: (text: string) => Promise<void>;
  readText?: () => Promise<string>;
};
declare const navigator: { clipboard?: ClipboardApi } | undefined;

const api = (): ClipboardApi | undefined => (typeof navigator === "undefined" ? undefined : navigator.clipboard);

const CLIPBOARD: GridClipboard = {
  get canRead() {
    return typeof api()?.readText === "function";
  },
  write: async (text) => {
    const write = api()?.writeText;
    if (!write) return false;
    try {
      await write.call(api(), text);
      return true;
    } catch {
      return false;
    }
  },
  read: async () => {
    const read = api()?.readText;
    if (!read) return null;
    try {
      return await read.call(api());
    } catch {
      return null;
    }
  },
};

export function useGridClipboard(): GridClipboard {
  return CLIPBOARD;
}
